import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthServiceService } from 'src/app/_services/AuthService.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {

  
  currentView = "emailconfigurations";

  @Input() isSaving = false;
  @Input() currentProject: any;
  @Input() currentApiId: number;
  @Output() subscriptionAdded: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _authService: AuthServiceService) { }

  ngOnInit() {
  }

  onSave() {

    var data = {
        "UserId": +this._authService.decodedToken.nameid,
        "APIId": this.currentApiId,
        "ProjectName": this.currentProject.projectShortName
      };

      console.log(data);

      this.subscriptionAdded.emit(data);

  }


}

